import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FAQPageJsonLd } from 'next-seo';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import Collapse from 'components/Collapse/Collapse';

import sanitizer from '../../../../utils/sanitizer';

import { StyledList, StyledListItem } from './styles/List';

function SectionFAQ({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  const faqQuestions = formatMessage({ id: `cms.pixPage.pixCardsArea[${index}].faqCategory.faqQuestions` });

  return (
    <>
      <Grid
        row
        id="faq"
        tag="section"
        spacingHorizontal={{
          xs: '4x',
          md: '8x',
          lg: '12x',
        }}
        spacingVertical={{
          xs: '16x',
          md: '20x',
          lg: '32x',
        }}
      >
        <Grid
          col={{ lg: 10 }}
          offset={{ lg: 1 }}
        >
          <Typography
            variant="title"
            color="black"
            colorVariant="default"
            gutterBottom={4}
            intlKey={`cms.pixPage.pixCardsArea[${index}].faqCategoryTitle`}
          />
          <StyledList>
            {faqQuestions.map((item, faqQuestionIndex) => (
              <StyledListItem key={item.id}>
                <Collapse
                  buttonId={`faq-button-${item.id}`}
                  contentId={`faq-content-${item.id}`}
                >
                  <Collapse.Header>
                    <Typography
                      color="black"
                      colorVariant="light"
                      variant="subtitle"
                    >
                      {item.title}
                    </Typography>
                  </Collapse.Header>
                  <Collapse.Body>
                    {formatMessage({
                      id: `cms.pixPage.pixCardsArea[${index}].faqCategory.faqQuestions[${faqQuestionIndex}].content`,
                    }, {
                      strong: props => <Typography tag="strong" variant="paragraph2" {...props} />,
                      p: props => <Typography marginBottom="5x" {...props} />,
                      a: props => <Link variant="action" {...props} />,
                    })}
                  </Collapse.Body>
                </Collapse>
              </StyledListItem>
            ))}
          </StyledList>
        </Grid>
      </Grid>
      <FAQPageJsonLd
        mainEntity={faqQuestions.map(item => ({
          questionName: sanitizer.forJSON(item.title),
          acceptedAnswerText: sanitizer.forJSON(item.content),
        }))}
      />
    </>
  );
}

SectionFAQ.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionFAQ);
